import React from 'react'
import PropTypes from 'prop-types';
import { footerLinksatQuoteFunnel, REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import { Container } from 'reactstrap';
import { formatPhoneNumber } from 'helpers/quote_funnel_helper';
import { AppConfiguration } from 'config';
import useFeatureFlags from 'hooks/useFeatureFlags';
import { addPadStart } from 'helpers/sf_utils';
import DOMPurify from 'dompurify';

const Footer = ({ answer_agent_profile, disclaimer,
    tracking_number, stepper, phone_number_text, tcpa_disclaimer_text
}) => {
    const [isFeatureFlagActive] = useFeatureFlags();
    const new_consent_ui_ff = isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_CUSTOM_CONSENT_UI)
    const sanitizedTcpaDisclaimer = DOMPurify.sanitize(tcpa_disclaimer_text);
    return (
        <div className='quote-funnel-answer-footer py-3'>
            <input id="leadid_token" name="universal_leadid" type="hidden" value="" />
            <Container>
                <div className="d-flex justify-content-center align-items-center m-4" >
                    {stepper && <div className='quote-funnel-answer-footer-img'>
                        {answer_agent_profile?.profile_img_url && <img src={answer_agent_profile?.profile_img_url} alt="User Logo" className="quote-funnel-answer-footer-user-log me-3" />}
                    </div>}
                    <div style={{ lineHeight: '1.3' }}>
                        <div className={stepper ? `quote-funnel-answer-footer-span-container-profile` : `quote-funnel-answer-footer-span-container`}>
                            <span className={`fs-18 fw-bold ${stepper ? 'text-left' : 'text-center'}`}>
                                {answer_agent_profile?.name}
                            </span>
                            <span className={`fs-18 ${stepper ? 'text-left' : 'text-center'}`}>{answer_agent_profile?.address}, {answer_agent_profile?.city}, {answer_agent_profile?.state} {addPadStart(answer_agent_profile?.zip_code)}</span>
                            <span
                                className={`fs-18 fw-bold ${stepper ? 'text-left' : 'text-center'}`}
                                style={{ color: '#3486e5' }}
                            >
                                {phone_number_text
                                    ? formatPhoneNumber(phone_number_text)
                                    : formatPhoneNumber(tracking_number)}
                            </span>
                        </div>
                    </div>
                </div>
                {
                    disclaimer && sanitizedTcpaDisclaimer && (
                        <div className="quote-funnel-answer-footer-span-container m-4">
                            <div
                                className='consent-confirmation-tcpa-disclosure'
                                id="leadid_tcpa_disclosure"
                                dangerouslySetInnerHTML={{ __html: sanitizedTcpaDisclaimer }}
                            ></div>
                        </div>
                    )}
                <div className={`quote-funnel-answer-footer-span-container m-4`}>
                    <span className='fs-16'>
                        Powered by Goal
                    </span>
                    <span>
                        <div className='footer-links mt-2'>
                            {footerLinksatQuoteFunnel.map((link, index) => (
                                <span key={index} className='me-2 mb-2' style={{ color: '#3486e5' }}>
                                    {link.link} {!(index == footerLinksatQuoteFunnel.length - 1) && <span className='footer-links-line ms-2'>|</span>}
                                </span>
                            ))}
                        </div>
                        <span className='small d-flex justify-content-center'>As part of our ongoing effort to provide you with the best possible service, Goal Platform LLC and its Service Providers may monitor and/or record and retain all activity on this website and its applicable links, through the use of cookies, tracking pixels or other methods, for informational and quality control purposes.</span>
                    </span>
                </div>
                <script id="LeadiDscript" type="text/javascript">
                    {
                        (function () {
                            var s = document.createElement('script');
                            s.id = 'LeadiDscript_campaign';
                            if (document.getElementById('LeadiDscript_campaign')) {
                                return;
                            }
                            s.type = 'text/javascript';
                            s.async = true;
                            s.src = '//create.lidstatic.com/campaign/672c6742-44b4-353c-7096-69fa44766978.js?snippet_version=2';
                            var ss = document.getElementsByTagName('script')[0];
                            ss.parentNode.insertBefore(s, ss);
                        })()
                    }
                </script>
                <noscript>
                    <img src='//create.leadid.com/noscript.gif?lac=0298D07E-FF3F-D76D-CB7B-C3D30DB04BDB&lck=672c6742-44b4-353c-7096-69fa44766978&snippet_version=2' />
                </noscript>
                <script type="text/javascript">
                    {
                        (function () {
                            var tf = document.createElement('script');
                            tf.type = 'text/javascript';
                            tf.async = true;
                            tf.id = 'trustedFormTokenFnId';
                            if (document.getElementById('trustedFormTokenFnId')) {
                                return;
                            }
                            tf.src = ("https:" == document.location.protocol ? 'https' : 'http') + "://api.trustedform.com/trustedform.js?field=xxTrustedFormCertUrl&l=" + new Date().getTime() + Math.random();
                            var s = document.getElementsByTagName('script')[0];
                            s.parentNode.insertBefore(tf, s);
                        })()
                    }
                </script>
                {new_consent_ui_ff && <script type="text/javascript"> {
                    (function () {
                        var s = document.createElement('script');
                        s.id = 'xxConsentConfirmationxx';
                        if (document.getElementById('xxConsentConfirmationxx')) {
                            return;
                        }
                        window.xxConsentConfirmationTokenxx = AppConfiguration.CONSENT_API_TOKEN
                        s.type = 'text/javascript';
                        s.async = true;
                        s.src = AppConfiguration.CONSENT_SCRIPT_URL
                        // Add load error handler
                        s.onerror = (error) => {
                            s?.remove();
                            try {
                                AppConfiguration.AIRBRAKE_NOTIFIER.notify({
                                    error: 'Consent script failed to load',
                                    details: {
                                        url: AppConfiguration.CONSENT_SCRIPT_URL,
                                        errorEvent: error,
                                        timestamp: new Date().toISOString()
                                    }
                                });
                            } catch (_error) { }
                        };
                        var ss = document.getElementsByTagName('script')[0];
                        ss.parentNode.insertBefore(s, ss);
                    })()
                }</script>}
                <noscript>
                    <img src="https://api.trustedform.com/ns.gif" />
                </noscript>

            </Container>
        </div>
    )
}
Footer.propTypes = {
    answer_agent_profile: PropTypes.object
};
export default Footer
